import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Modal, Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import QuestionsContainer from '../../common/QuestionsContainer';
import AnswerAttribute from '../../common/AnswerAttribute';
import { getRequest, putRequest } from '../../../requestUtils';
import './WorkPreferences.scss';
import ProfileSuggestions from '../../ConsultantOnboarding/ProfileSuggestions';
import profileInterfaceAmico from '../../../../assets/images/profile-interface-amico.svg';
import { processedProfileSuggestions } from '../../ConsultantOnboarding/onboardingUtils';
var displayNumericRangeValue = function displayNumericRangeValue(low, high, unit) {
  var symbol = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  if (low && low.toString().length > 0 && high && high.toString().length > 0) {
    return "".concat(symbol).concat(low, " - ").concat(symbol).concat(high).concat(unit);
  }
  return "".concat(symbol).concat(low || '').concat(high || '').concat(unit);
};
var renderField = function renderField(attribute, icon, answer) {
  return /*#__PURE__*/React.createElement("div", {
    className: "work-preference ".concat(attribute, " body-text-2 me-4")
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa ".concat(icon, " me-3")
  }), answer);
};
var WorkPreferences = /*#__PURE__*/function (_Component) {
  function WorkPreferences(props) {
    var _this;
    _classCallCheck(this, WorkPreferences);
    _this = _callSuper(this, WorkPreferences, [props]);
    _this.state = {
      editMode: false,
      isHovering: false,
      showModal: props.showModal,
      showProfileSuggestionModal: false,
      answers: null,
      newResume: false,
      editErrorPresent: false
    };
    _this.getAnswers = _this.getAnswers.bind(_this);
    _this.updateAnswers = _this.updateAnswers.bind(_this);
    _this.handleMouseOver = _this.handleMouseOver.bind(_this);
    _this.handleMouseLeave = _this.handleMouseLeave.bind(_this);
    _this.handleUpdateErrorState = _this.handleUpdateErrorState.bind(_this);
    _this.handleShowModal = _this.handleShowModal.bind(_this);
    _this.handleCloseModal = _this.handleCloseModal.bind(_this);
    _this.handleCloseProfileSuggestionModal = _this.handleCloseProfileSuggestionModal.bind(_this);
    _this.onSaveProfileSuggestion = _this.onSaveProfileSuggestion.bind(_this);
    _this.onUpdateCompletionPercentage = _this.onUpdateCompletionPercentage.bind(_this);
    _this.handleNewResume = _this.handleNewResume.bind(_this);
    _this.renderPreferredHoursPerWeek = _this.renderPreferredHoursPerWeek.bind(_this);
    return _this;
  }
  _inherits(WorkPreferences, _Component);
  return _createClass(WorkPreferences, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateAnswers();
    }
  }, {
    key: "onUpdateCompletionPercentage",
    value: function onUpdateCompletionPercentage(answer) {
      var updateCompletionPercentage = this.props.updateCompletionPercentage;
      var newResume = this.state.newResume;
      updateCompletionPercentage();
      if (answer.question_key === 'Resume' && newResume) {
        this.setState({
          showProfileSuggestionModal: true
        });
      }
    }
  }, {
    key: "onSaveProfileSuggestion",
    value: function onSaveProfileSuggestion() {
      var _this$props = this.props,
        claimInfoUrl = _this$props.claimInfoUrl,
        csrfToken = _this$props.csrfToken,
        hasChanged = _this$props.hasChanged;
      var data = processedProfileSuggestions(this.props);
      data = Object.keys(data).filter(function (key) {
        return hasChanged[_.camelCase(key)];
      }).reduce(function (cur, key) {
        return Object.assign(cur, _defineProperty({}, key, data[key]));
      }, {});
      putRequest(claimInfoUrl, {
        claim_info: data
      }, csrfToken).then(function () {
        window.location.reload();
      });
    }
  }, {
    key: "getAnswers",
    value: function () {
      var _getAnswers = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this$props2, questionCategoryId, questionableId, questionableType, questionnaireName, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this$props2 = this.props, questionCategoryId = _this$props2.questionCategoryId, questionableId = _this$props2.questionableId, questionableType = _this$props2.questionableType, questionnaireName = _this$props2.questionnaireName;
              _context.next = 3;
              return getRequest('/question_answers/answers', {
                questionnaire_name: questionnaireName,
                question_category_id: questionCategoryId,
                questionable_id: questionableId,
                questionable_type: questionableType
              });
            case 3:
              response = _context.sent;
              return _context.abrupt("return", response);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getAnswers() {
        return _getAnswers.apply(this, arguments);
      }
      return getAnswers;
    }()
  }, {
    key: "updateAnswers",
    value: function () {
      var _updateAnswers = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.getAnswers();
            case 2:
              response = _context2.sent;
              this.setState({
                answers: response.data
              });
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function updateAnswers() {
        return _updateAnswers.apply(this, arguments);
      }
      return updateAnswers;
    }()
  }, {
    key: "handleNewResume",
    value: function handleNewResume(showSuggestions) {
      this.setState({
        newResume: showSuggestions
      });
    }
  }, {
    key: "handleMouseOver",
    value: function handleMouseOver() {
      this.setState({
        isHovering: true
      });
    }
  }, {
    key: "handleMouseLeave",
    value: function handleMouseLeave() {
      var showModal = this.state.showModal;
      if (!showModal) {
        this.setState({
          isHovering: false
        });
      }
    }
  }, {
    key: "handleUpdateErrorState",
    value: function handleUpdateErrorState(error) {
      this.setState({
        editErrorPresent: error
      });
    }
  }, {
    key: "handleShowModal",
    value: function handleShowModal() {
      this.setState({
        showModal: true
      });
    }
  }, {
    key: "handleCloseModal",
    value: function handleCloseModal() {
      var _this2 = this;
      var _this$props3 = this.props,
        updateCompletionPercentage = _this$props3.updateCompletionPercentage,
        updateAvailability = _this$props3.updateAvailability,
        updateHourlyRate = _this$props3.updateHourlyRate;
      this.getAnswers().then(function (response) {
        _this2.setState({
          answers: response.data,
          showModal: false,
          isHovering: false
        });
        updateAvailability(response.data.find(function (a) {
          return a.question_key === 'Is Available';
        }).answer);
        updateHourlyRate(response.data.find(function (a) {
          return a.question_key === 'Hourly Rate Range';
        }).answer);
        updateCompletionPercentage();
      });
    }
  }, {
    key: "handleCloseProfileSuggestionModal",
    value: function handleCloseProfileSuggestionModal() {
      this.setState({
        showProfileSuggestionModal: false
      });
    }
  }, {
    key: "renderAdd",
    value: function renderAdd(attribute, text) {
      var _this3 = this;
      return /*#__PURE__*/React.createElement("div", {
        className: "work-preference"
      }, /*#__PURE__*/React.createElement("a", {
        className: "add-answer ".concat(attribute, " body-text-3 me-3"),
        tabIndex: 0,
        role: "button",
        onClick: function onClick() {
          return _this3.handleShowModal();
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-plus"
      }), "Add ".concat(text)));
    }
  }, {
    key: "renderAttribute",
    value: function renderAttribute(attribute, icon, answer, addText) {
      var fullView = this.props.fullView;
      if (answer) {
        return renderField(attribute, icon, answer);
      }
      if (fullView) {
        return this.renderAdd(attribute, addText);
      }
      return null;
    }
  }, {
    key: "renderHourlyRateRange",
    value: function renderHourlyRateRange(hourlyRate) {
      var fullView = this.props.fullView;
      if (hourlyRate && (!hourlyRate.answer || !hourlyRate.answer.low && !hourlyRate.answer.high)) {
        if (fullView) {
          return /*#__PURE__*/React.createElement("div", {
            className: "work-preference body-text-3"
          }, this.renderAdd('hourly rate', 'Hourly Rate'));
        }
        return null;
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "work-preference"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fas fa-dollar-sign"
      }), displayNumericRangeValue(Math.round(hourlyRate.answer.low), Math.round(hourlyRate.answer.high), '/hr', '$'));
    }
  }, {
    key: "renderPreferredHoursPerWeek",
    value: function renderPreferredHoursPerWeek(availability) {
      if (availability && (!availability.answer || !availability.answer.id)) {
        return /*#__PURE__*/React.createElement("div", {
          className: "work-preference availability body-text-3"
        }, this.renderAdd('hours_per_week', 'Hours Per Week'));
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "work-preference availability"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fas fa-clock"
      }), "Preferred hours per week:", ' ', availability.answer.value);
    }
  }, {
    key: "renderAvailability",
    value: function renderAvailability(answers) {
      var isAvailable = answers.find(function (a) {
        return a.question_key === 'Is Available';
      });
      var availability = answers.find(function (a) {
        return a.question_key === 'Availability';
      });
      if (isAvailable.answer.value === 'yes') {
        return /*#__PURE__*/React.createElement(Fragment, null, this.renderPreferredHoursPerWeek(availability));
      }
      if (isAvailable.answer.value === 'no') {
        return /*#__PURE__*/React.createElement("div", {
          className: "work-preference g-row--always"
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("i", {
          className: "fas fa-calendar"
        })), /*#__PURE__*/React.createElement("div", null, "Not available"));
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "work-preference availability body-text-3"
      }, this.renderAdd('availability', 'Availability'));
    }
  }, {
    key: "renderForm",
    value: function renderForm() {
      var _this$props4 = this.props,
        questionnaireQuestions = _this$props4.questionnaireQuestions,
        questionableId = _this$props4.questionableId,
        questionableType = _this$props4.questionableType,
        questionnaireName = _this$props4.questionnaireName,
        csrfToken = _this$props4.csrfToken;
      return /*#__PURE__*/React.createElement("div", {
        className: "work-preferences-form"
      }, /*#__PURE__*/React.createElement(QuestionsContainer, {
        questionnaireName: questionnaireName,
        questionIds: questionnaireQuestions,
        questionableId: questionableId,
        questionableType: questionableType,
        csrfToken: csrfToken,
        handleToggleSave: this.handleUpdateErrorState,
        owner: true
      }));
    }
  }, {
    key: "renderEdit",
    value: function renderEdit() {
      var _this4 = this;
      var editMode = this.props.editMode;
      var isHovering = this.state.isHovering;
      if (isHovering || editMode) {
        return /*#__PURE__*/React.createElement("a", {
          className: "edit-work-preference medium-weight",
          tabIndex: 0,
          role: "button",
          onClick: function onClick() {
            return _this4.handleShowModal();
          }
        }, "Edit");
      }
      return null;
    }
  }, {
    key: "renderEditWorkPreference",
    value: function renderEditWorkPreference() {
      var _this5 = this;
      var editMode = this.props.editMode;
      var isHovering = this.state.isHovering;
      if (isHovering || editMode) {
        return /*#__PURE__*/React.createElement("a", {
          className: "edit-work-preference",
          tabIndex: 0,
          role: "button",
          onClick: function onClick() {
            return _this5.handleShowModal();
          }
        }, "Edit");
      }
      return null;
    }
  }, {
    key: "renderProfileSuggestions",
    value: function renderProfileSuggestions() {
      var _this$props5 = this.props,
        questionableId = _this$props5.questionableId,
        questionableType = _this$props5.questionableType,
        questionnaireName = _this$props5.questionnaireName,
        userId = _this$props5.userId;
      return /*#__PURE__*/React.createElement("div", {
        className: "profile-suggestions-wrapper"
      }, /*#__PURE__*/React.createElement("div", {
        className: "header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "content"
      }, /*#__PURE__*/React.createElement("h1", {
        className: "title"
      }, "We found some profile suggestions for you!"), /*#__PURE__*/React.createElement("p", {
        className: "description"
      }, "Any existing information in the fields you select below will be overwritten. Uncheck any items you want to leave out.")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
        src: profileInterfaceAmico,
        alt: "profile interface amico",
        className: "brand-img",
        height: 139,
        width: 142
      }))), /*#__PURE__*/React.createElement("div", {
        className: "profile-suggestions"
      }, /*#__PURE__*/React.createElement(ProfileSuggestions, {
        questionnaireName: questionnaireName,
        questionableId: questionableId,
        questionableType: questionableType,
        userId: userId,
        fromOnboarding: false
      })), /*#__PURE__*/React.createElement("div", {
        className: "footer"
      }, /*#__PURE__*/React.createElement(Button, {
        variant: "secondary",
        onClick: this.handleCloseProfileSuggestionModal
      }, "Skip"), /*#__PURE__*/React.createElement(Button, {
        variant: "primary",
        onClick: this.onSaveProfileSuggestion
      }, "Update My Profile")));
    }
  }, {
    key: "renderAnswerAttribute",
    value: function renderAnswerAttribute(answer, customClass, updateCallback) {
      var _this$props6 = this.props,
        questionCategoryId = _this$props6.questionCategoryId,
        questionnaireId = _this$props6.questionnaireId,
        questionableId = _this$props6.questionableId,
        questionableType = _this$props6.questionableType,
        questionnaireName = _this$props6.questionnaireName,
        csrfToken = _this$props6.csrfToken,
        fullView = _this$props6.fullView,
        editMode = _this$props6.editMode,
        userId = _this$props6.userId;
      return /*#__PURE__*/React.createElement(AnswerAttribute, {
        customClass: customClass,
        answer: answer,
        questionCategoryId: questionCategoryId,
        questionableId: questionableId,
        questionableType: questionableType,
        csrfToken: csrfToken,
        questionnaireId: questionnaireId,
        questionnaireName: questionnaireName,
        fullView: fullView,
        editMode: editMode,
        updateCompletionPercentage: updateCallback,
        updateAnswers: this.updateAnswers,
        userId: userId,
        handleNewResume: this.handleNewResume
      });
    }
  }, {
    key: "renderModals",
    value: function renderModals() {
      var _this$state = this.state,
        showModal = _this$state.showModal,
        showProfileSuggestionModal = _this$state.showProfileSuggestionModal,
        editErrorPresent = _this$state.editErrorPresent;
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Modal, {
        show: showModal,
        onHide: this.handleCloseModal
      }, /*#__PURE__*/React.createElement(Modal.Header, {
        closeButton: true,
        className: "no-border-bottom"
      }), /*#__PURE__*/React.createElement(Modal.Body, {
        className: "style-guide"
      }, this.renderForm()), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
        variant: "primary",
        disabled: editErrorPresent,
        onClick: this.handleCloseModal
      }, "Save"))), /*#__PURE__*/React.createElement(Modal, {
        size: "lg",
        dialogClassName: "profile-suggestions-modal",
        show: showProfileSuggestionModal,
        onHide: this.handleCloseProfileSuggestionModal
      }, /*#__PURE__*/React.createElement(Modal.Header, {
        closeButton: true,
        className: "no-border-bottom"
      }), /*#__PURE__*/React.createElement(Modal.Body, {
        className: "style-guide"
      }, this.renderProfileSuggestions()), /*#__PURE__*/React.createElement(Modal.Footer, null)));
    }
  }, {
    key: "renderWorkPreferences",
    value: function renderWorkPreferences() {
      var answers = this.state.answers;
      var _this$props7 = this.props,
        fullView = _this$props7.fullView,
        needsAttention = _this$props7.needsAttention,
        onAttentionClick = _this$props7.onAttentionClick,
        questionCategoryId = _this$props7.questionCategoryId;
      var hourlyRate = answers.find(function (a) {
        return a.question_key === 'Hourly Rate Range';
      });
      var roleType = answers.find(function (a) {
        return a.question_key === 'Role Type';
      });
      if (!fullView && (!hourlyRate || !hourlyRate.answer || !hourlyRate.answer.low && !hourlyRate.answer.high) && (!roleType || roleType.answer.length === 0)) {
        return null;
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "profile-section work-preferences body-text-2"
      }, /*#__PURE__*/React.createElement("div", {
        onMouseOver: this.handleMouseOver,
        onFocus: this.handleMouseOver,
        onMouseLeave: this.handleMouseLeave
      }, /*#__PURE__*/React.createElement("h2", {
        className: "mb-4"
      }, "Work Preferences", fullView && needsAttention && /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "attention-badge",
        "aria-label": "Work Preferences needs attention",
        onClick: function onClick() {
          return onAttentionClick(questionCategoryId);
        }
      }), /*#__PURE__*/React.createElement("span", {
        className: "body-text-2"
      }, this.renderEditWorkPreference())), this.renderHourlyRateRange(hourlyRate), this.renderAttribute('employment-preference', 'fa-atom', roleType && roleType.answer.map(function (a) {
        return a.label;
      }).join(' & '), 'Work Preference'), answers.find(function (a) {
        return a.question_key === 'Is Available';
      }) && fullView && this.renderAvailability(answers)));
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;
      var answers = this.state.answers;
      var fullView = this.props.fullView;
      if (!answers) {
        return /*#__PURE__*/React.createElement("div", {
          className: "profile-section work-preferences body-text-2"
        }, "Work Preferences");
      }
      var resume = answers.find(function (a) {
        return a.question_key === 'Resume';
      });
      var linkedin = answers.find(function (a) {
        return a.question_key === 'Linkedin';
      });
      return /*#__PURE__*/React.createElement("div", null, fullView && /*#__PURE__*/React.createElement("div", {
        className: "profile-section preferences body-text-2"
      }, resume && this.renderAnswerAttribute(resume, 'mb-4', function () {
        return _this6.onUpdateCompletionPercentage(resume);
      }), linkedin && this.renderAnswerAttribute(linkedin, 'mb-4', this.props.updateCompletionPercentage)), this.renderWorkPreferences(), this.renderModals());
    }
  }]);
}(Component);
WorkPreferences.propTypes = {
  questionCategoryId: PropTypes.number.isRequired,
  questionableId: PropTypes.number.isRequired,
  questionableType: PropTypes.string.isRequired,
  questionnaireName: PropTypes.string.isRequired,
  questionnaireQuestions: PropTypes.arrayOf(PropTypes.number).isRequired,
  csrfToken: PropTypes.string.isRequired,
  editMode: PropTypes.bool,
  updateCompletionPercentage: PropTypes.func.isRequired,
  updateAvailability: PropTypes.func.isRequired,
  updateHourlyRate: PropTypes.func.isRequired,
  questionnaireId: PropTypes.number.isRequired,
  fullView: PropTypes.bool,
  userId: PropTypes.string.isRequired,
  claimInfoUrl: PropTypes.string.isRequired,
  hasChanged: PropTypes.shape({}).isRequired,
  showModal: PropTypes.bool,
  needsAttention: PropTypes.bool,
  onAttentionClick: PropTypes.func
};
WorkPreferences.defaultProps = {
  fullView: true,
  editMode: false,
  showModal: false,
  needsAttention: false,
  onAttentionClick: function onAttentionClick() {}
};
var mapStateToProps = function mapStateToProps(state) {
  var _state$profileSuggest = state.profileSuggestions,
    profileSuggestions = _state$profileSuggest.profileSuggestions,
    hasChanged = _state$profileSuggest.hasChanged;
  return _objectSpread(_objectSpread({}, profileSuggestions.merged), {}, {
    hasChanged: hasChanged
  });
};
export default connect(mapStateToProps)(WorkPreferences);